module.exports = __webpack_public_path__ + "img/gb13871-92-8x24x7.prt.7ee818d4.jpg";